/**
 * Видаляє з відповіді GraphQL всі поля __typename
 * @param {*} data
 * @returns
 */
export function removeTypename(data) {
  if (Array.isArray(data)) {
    return data.map(item => removeTypename(item))
  } else if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce((acc, key) => {
      if (key !== '__typename') {
        acc[key] = removeTypename(data[key])
      }
      return acc
    }, {})
  }
  return data
}
